import React from "react";
import {
  TextField,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  TableContainer,
  Table,
  Paper,
} from "@mui/material";

function NotesSummary({ invoiceData }) {
  return (
    <TableContainer component={Paper} style={{ width: "100%" }}>
      <Table size="small">
        <TableHead style={{ textTransform: "uppercase" }}>
          <TableRow>
            <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
              Notes
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                required
                multiline
                rows={2}
                label=""
                variant="standard"
                disabled
                value={invoiceData.notes}
                style={{ width: "100%" }}
                InputProps={{
                  disableUnderline: true,
                }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default NotesSummary;
